import React, { memo, useCallback, useEffect } from 'react';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { AkFlag, useFlagsService } from '@atlassian/jira-flags';
import type { FlagCustomRenderProps } from '@atlassian/jira-flags/src/services/types';
import { useIntl } from '@atlassian/jira-intl';
import { useLazyGoals } from '../../controllers/hooks/use-lazy-goals';
import messages from './messages';

const GoalsErrorFlag = () => {
	const { showFlag, dismissFlag } = useFlagsService();
	const [{ isError }, { resetError }] = useLazyGoals();
	const { formatMessage } = useIntl();
	const flagId = 'jpo-goals-error-flag';

	const onDismissed = useCallback(() => {
		resetError();
		dismissFlag(flagId);
	}, [resetError, dismissFlag]);

	useEffect(() => {
		isError &&
			showFlag({
				id: flagId,
				render: (flagCustomRendererProps: FlagCustomRenderProps) => (
					<AkFlag
						{...flagCustomRendererProps}
						id={flagId}
						icon={
							<ErrorIcon
								label={formatMessage(messages.errorFlagIconLabel)}
								primaryColor={token('color.icon.danger', colors.R300)}
							/>
						}
						title={formatMessage(messages.errorFlagTitle)}
						description={formatMessage(messages.errorFlagDescription)}
						onDismissed={onDismissed}
					/>
				),
			});
	}, [isError, showFlag, formatMessage, onDismissed]);

	return null;
};

export default memo<{}>(GoalsErrorFlag);
